<mat-toolbar color="primary">
    <span>DevOps</span>
</mat-toolbar>
<mat-list>
    <mat-list-item *ngFor="let menuItem of menuItems" [routerLinkActive]="['is-active']" [routerLink]="[menuItem.path]">
        <mat-icon matListIcon>{{menuItem.icon}}</mat-icon>
        <p matLine>{{menuItem.title}}</p>
    </mat-list-item>
</mat-list>

<mat-divider></mat-divider>
<mat-list>
    <mat-list-item>
        <button mat-raised-button color="secondary">
            <mat-icon matListIcon>exit_to_app</mat-icon>
            Salir
        </button>
        <button mat-raised-button color="secondary">
            <mat-icon matListIcon>login</mat-icon>
            Login
        </button>
    </mat-list-item>
</mat-list>
<div class="inner-content">
    <mat-list>
        <mat-list-item class="is-active">
            <mat-label> {{'BOTONES.IDIOMA' | translate}}: </mat-label>
            <mat-select placeholder="Select your option" [(value)]="idiomaSelect"
                (selectionChange)="onChangeIdioma($event)">
                <mat-option *ngFor="let idioma of idiomas" [value]="idioma">
                    {{idioma | uppercase }}
                </mat-option>
            </mat-select>
        </mat-list-item>
    </mat-list>

    <div class="logo">
        <div class="logo-img">
            <img src="/assets/images/marca_blanco.png" alt="Marca blanco"/>
        </div>
    </div>
</div>
